var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKickEmotesBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "emotes") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emotes",
    stroke: "none",
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,2 L5,2 L2,5 L2,11 L5,14 L11,14 L14,11 L14,5 L11,2 Z M10.25,5 C10.8725,5 11.375,5.5025 11.375,6.125 C11.375,6.7475 10.8725,7.25 10.25,7.25 C9.6275,7.25 9.125,6.7475 9.125,6.125 C9.125,5.5025 9.6275,5 10.25,5 Z M5.75,5 C6.3725,5 6.875,5.5025 6.875,6.125 C6.875,6.7475 6.3725,7.25 5.75,7.25 C5.1275,7.25 4.625,6.7475 4.625,6.125 C4.625,5.5025 5.1275,5 5.75,5 Z M11.75,9.875 C11.0188,10.6062 10.6062,11.0188 9.875,11.75 L6.125,11.75 C5.39375,11.0188 4.98125,10.6062 4.25,9.875 L4.25,8.75 L11.75,8.75 L11.75,9.875 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKickEmotesBtn);
export default __webpack_public_path__ + "static/media/kick-emotes-btn.5e9b6489cca8c491d01b005946d5653f.svg";
export { ForwardRef as ReactComponent };